// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__FtCjb","list":"PatternAutocomplete_list__1tJkk"};